var map = {
	"./general-store": [
		"./src/Web/scripts/stores/general-store.js"
	],
	"./general-store.js": [
		"./src/Web/scripts/stores/general-store.js"
	],
	"./pull-request-store": [
		"./src/Web/scripts/stores/pull-request-store.js"
	],
	"./pull-request-store.js": [
		"./src/Web/scripts/stores/pull-request-store.js"
	],
	"./starfield-store": [
		"./src/Web/scripts/stores/starfield-store.js"
	],
	"./starfield-store.js": [
		"./src/Web/scripts/stores/starfield-store.js"
	],
	"./test-store": [
		"./src/Web/scripts/stores/test-store.js",
		"src_Web_scripts_stores_test-store_js"
	],
	"./test-store.js": [
		"./src/Web/scripts/stores/test-store.js",
		"src_Web_scripts_stores_test-store_js"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/Web/scripts/stores lazy recursive ^\\.\\/.*$";
module.exports = webpackAsyncContext;